import apollo from 'graphql/apollo';
import { sendEmailMutation } from 'graphql/mutations';

const sendEmail = async ({ shoppingCart }) =>
  apollo.mutate({
    mutation: sendEmailMutation,
    variables: { shoppingCart },
  });
export default sendEmail;
